import { MemoryBook } from "../../../../../store/slice/MemoryBookSlice";
import { MemoryBookAssignmentApiItem } from "./service/memoryBook.api";

export const mapAssignmentToMemoryBook = (
  assignment: MemoryBookAssignmentApiItem,
): MemoryBook => {
  const physicalComments = assignment.memory_book?.physical_comments ?? 0;
  const donePhysical = assignment.memory_book?.done_comments ?? 0;
  const unfinishedPhysical = Math.max(physicalComments - donePhysical, 0);

  const onlineComments = assignment.online_comments || 0;
  const unfinishedOnline =
    assignment.online_remaining_comments ?? onlineComments;
  const doneOnline = onlineComments - unfinishedOnline;

  const totalUnfinished = unfinishedPhysical + unfinishedOnline;

  const deceasedName = assignment.stream?.booking?.deceased?.[0]
    ? `${assignment.stream.booking.deceased[0].first_name} ${assignment.stream.booking.deceased[0].surname}`
    : "Unnamed Book";

  const streamTitle = assignment.stream?.title || "Untitled Stream";
  const deceasedPhoto = assignment.stream?.booking?.deceased?.[0]?.person_image;

  return {
    id: String(assignment.stream?.id),
    assignmentId: assignment.id,
    title: streamTitle || deceasedName,
    thumbnail: deceasedPhoto,
    physical_comments: physicalComments,
    unfinished_comments: unfinishedPhysical,
    online_comments: onlineComments,
    unfinished_online_comments: unfinishedOnline,
    total_comments: physicalComments + onlineComments,
    dueDate: assignment.due_date,
    assignedAt: assignment.assigned_at,
    status:
      totalUnfinished === 0
        ? "completed"
        : donePhysical > 0 || doneOnline > 0
          ? "in_progress"
          : "not_started",
  };
};
